<template>
  <b-modal
    :visible="value"
    title="Editar Advertencias"
    size="md"
    hide-footer
    @change="modalChangeEvent"
  >
    <BfInput
      :value="internalWarningValue"
      data-key="advertencias"
      type="textarea"
      label="Aviso"
      placeholder="Introduce un aviso"
      :left-border="false"
      :errors="formErrors"
      @update="updateWarningField"
    />

    <div class="mt-4 d-flex justify-content-between">
      <BfButton
        variant="red"
        class="mr-3"
        @click="clearWarning"
      >
        Borrar aviso
      </BfButton>
      <BfButton @click="saveFormData" :disabled="disableSaveButton">
        Guardar Aviso
      </BfButton>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ChargeWarningModal',

  props: {
    warningValue: {
      type: String,
    },

    formErrors: {
      type: Object,
    },

    value: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      internalWarningValue: this.warningValue,
    };
  },

  methods: {
    updateWarningField({ value }) {
      this.internalWarningValue = value;
    },

    modalChangeEvent(visible) {
      this.$emit('input', visible);
      if (visible) {
        this.internalWarningValue = this.warningValue;
      }
    },

    clearWarning() {
      this.updateWarningField({ value: null });
      this.saveFormData();
    },

    saveFormData() {
      this.$emit('save-data', { key: 'advertencias', value: this.internalWarningValue });
    },
  },

  computed: {
    disableSaveButton() {
      return !this.internalWarningValue;
    },
  },

  watch: {
    warningValue(newValue) {
      this.internalWarningValue = newValue;
    },
  },
};
</script>
